import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import NotificationBanner from "../../../../../components/Connect/NotificationBanner";
import BreakdownChartCard from "../../../../../components/Dashboard/BreakdownChartCard";
import DashboardSummaryStrip from "../../../../../components/Dashboard/DashboardSummaryStrip";
import TimeSeriesCard from "../../../../../components/Dashboard/TimeSeriesCard";
import { formatMoney, formatNumber } from "../../../../../libs/dashboardOverview";

const OverviewSection = ({ overview, accountId }) => {
  const [timeframe, setTimeframe] = useState(6);

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          Overview
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Earnings, work progress, and opportunity movement.
        </Typography>
      </Stack>
      <NotificationBanner accountId={accountId}/>
      <DashboardSummaryStrip items={overview?.summary || []} />
      <TimeSeriesCard
        title="Earnings over time"
        subtitle="Contractor invoice volume by month"
        data={overview?.seriesByRange?.[timeframe] || overview?.series || []}
        formatter={formatMoney}
        timeframe={timeframe}
        onTimeframeChange={setTimeframe}
      />
      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" } }}>
        <Box>
          <BreakdownChartCard title="Invoice status" subtitle="Amount by invoice state" data={overview?.breakdowns?.invoices || []} formatter={formatMoney} color="#1a73e8" />
        </Box>
        <Box>
          <BreakdownChartCard title="Work status" subtitle="Hours by timesheet state" data={overview?.breakdowns?.work || []} formatter={formatNumber} color="#05690D" />
        </Box>
        <Box>
          <BreakdownChartCard title="Opportunity funnel" subtitle="Invitations and engagements" data={overview?.breakdowns?.opportunities || []} formatter={formatNumber} color="#f9ab00" />
        </Box>
      </Box>
    </Stack>
  );
};

export default OverviewSection;
